import { render, staticRenderFns } from "./RoleAuthority.vue?vue&type=template&id=768b8dfc&scoped=true"
import script from "./RoleAuthority.vue?vue&type=script&lang=js"
export * from "./RoleAuthority.vue?vue&type=script&lang=js"
import style0 from "./RoleAuthority.vue?vue&type=style&index=0&id=768b8dfc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768b8dfc",
  null
  
)

export default component.exports